import { render, staticRenderFns } from "./TaskRequestPagination.vue?vue&type=template&id=17218b3c&scoped=true"
import script from "./TaskRequestPagination.vue?vue&type=script&lang=js"
export * from "./TaskRequestPagination.vue?vue&type=script&lang=js"
import style0 from "./TaskRequestPagination.vue?vue&type=style&index=0&id=17218b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17218b3c",
  null
  
)

export default component.exports